import { Badge } from "@mantine/core";

import { PerformanceIndicator } from "./PerformanceIndicator";

import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type PerformanceBadgeProps = {
  suffix?: string;
  value: number;
} & MantineStyleProps;

export const PerformanceBadge: FC<PerformanceBadgeProps> = ({ suffix, value, ...props }) => {
  const color = value > 0 ? "success.2" : value < 0 ? "danger.2" : "gray.2";

  return (
    <Badge radius="sm" color={color} pl="4" {...props}>
      <PerformanceIndicator
        value={value}
        color="var(--mantine-color-secondary-9)"
        iconSize={12}
        suffix={suffix}
        iconBold={true}
      />
    </Badge>
  );
};
